
'use strict';

var SessionController = require('./sessionController'),
  SessionModel = require('./sessionModel');

exports.sessionController = new SessionController({
  model: new SessionModel()
});



// WEBPACK FOOTER //
// ./assets/js/session/index.js